module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/product-model-1-1c9584431fbd818893fe10c3773df915.jpg";